import {
    Box,
    Button,
    Checkbox,
    Chip,
    FormControl,
    FormControlLabel,
    Grow,
    IconButton,
    InputAdornment,
    MenuItem,
    Modal,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    styled,
    TextField,
    Typography,
} from "@mui/material";
import { ReactComponent as ArrowDown } from "../../../../assets/icons/Arrowdown.svg"
import { ReactComponent as YellowGold } from "../../../../assets/icons/YellowGoldBar.svg";
import { ReactComponent as PinkGold } from "../../../../assets/icons/RoseGoldBar.svg";
import { ReactComponent as WhiteGold } from "../../../../assets/icons/WhiteGoldBar.svg";
import { ReactComponent as Vector } from "../../../../assets/icons/ic_round-close.svg";
import { ReactComponent as Close } from "../../../../assets/icons/Cross_Box.svg";
import React, { useEffect, useState } from "react";
import "./CartPageModal.css";
// import NewSearchBar from "../../search/NewSeachBar";
import { getIcon } from "../../../../utils/iconsConfig";
import { useGlobalContext } from "../../../../context/GlobalContext"
import Selectinput from "features/order_client_details/components/Selectinput";
import { useFilter } from "context/FilterContext";
import useItemSizes from "hooks/useItemSizes";

const CustomRadioGroup = ({ label, options, value, onChange, name }) => (
    <Box marginBottom="1vw">
        <Typography className="filter-label">{label}</Typography>
        <FormControl component="fieldset">
            <RadioGroup
                row
                value={value}
                onChange={onChange}
                name={name}
                sx={{
                    display: "flex",
                    gap: "1vw",
                    rowGap: "0",
                }}
            >
                {options.map(({ label, value, icon }) => (
                    <FormControlLabel
                        key={value}
                        value={value}
                        control={
                            <Radio
                                sx={{
                                    color: "#B0B0B0",
                                    "&.Mui-checked": {
                                        color: "#50C878",
                                    },
                                    "& .MuiSvgIcon-root": {
                                        fontSize: "1.3vw", // Increase this value to make the circle bigger
                                    },
                                }}
                            />
                        }
                        label={
                            <Box display="flex" alignItems="center" gap={".5vw"}>
                                <Typography
                                    sx={{
                                        fontFamily: "Poppins",
                                        fontWeight: 600,
                                        fontSize: ".75vw",
                                        lineHeight: "100%",
                                    }}
                                >
                                    {label}
                                </Typography>
                                {icon && <Box>{icon}</Box>}
                            </Box>
                        }
                        className="fieldset-label"
                    />
                ))}
            </RadioGroup>
        </FormControl>
    </Box>
);

const StyledButton = styled(Button)({
    backgroundColor: "#50C878",
    width: "100%",
    height: "2vw",
    padding: ".45vw 2vw",
    color: "#000000",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: ".7vw",
    lineHeight: "100%",
    borderRadius: ".3vw",
    "&:hover": {
        backgroundColor: "#3da862",
        color: "#000000",
    },
    "&.Mui-disabled": {
        backgroundColor: "#949795ff",
        color: "#000000",
    },
});

const CircularCheckbox = styled(Checkbox)(({ theme }) => ({
    width: "20px",
    height: "20px",
    padding: "1px",
    borderRadius: "6px",
    border: "1.5px solid black",
    backgroundColor: "white",

    "& .MuiSvgIcon-root": {
        display: "none", // Hide the default checkbox icon
    },

    "&::before": {
        content: '"✓"',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        color: "transparent",
        fontSize: ".5vw",
        fontWeight: "bold",
    },
    "&.Mui-checked": {
        backgroundColor: "#50C878",
        border: ".025vw solid black",

        "&::before": {
            color: "white",
        },
    },

    "&.Mui-focusVisible": {
        outline: "none",
        boxShadow: "none",
    },
}));

const CartPageModal = ({
    headLabel,
    openModal,
    handleClose,
    setRemark,
    remark,
}) => {
    const { cartData } = useGlobalContext();
    const { setFilterValues ,filterValues} = useFilter();
    const [size, setSize] = useState("");


    const categoriesList = [
        ...new Set(cartData?.map((item) => item?.categoryName)),
    ];

    const goldColorMap = {
        "Pink": "Rose Gold",
        "White": "White Gold",
        "Yellow": "Yellow Gold",
    };
    const goldColorReverseMap = {
        "Rose Gold": "Pink",
        "White Gold": "White",
        "Yellow Gold": "Yellow",
    };

    const getDefaultSelectedValues = () => ({
        diamondQuality: filterValues["Diamond Quality"]?.[0] || "VS-GH",
        goldQuality: filterValues["Gold Purity"]?.[0] || "18K",
        goldColor: goldColorReverseMap[filterValues["Gold Color"]?.[0]] || "Pink",
        categories: filterValues.categoriesName || [],
    });

    const [selectedValues, setSelectedValues] = useState({
        diamondQuality: "",
        goldQuality: "",
        goldColor: "",
        rhodium: "",
        categories: [],
    });
    const categoryNameForSize = selectedValues.categories.length === 1 ? selectedValues.categories[0] : null;
    const { data: sizeData } = useItemSizes(
        categoryNameForSize ? { categoryName: categoryNameForSize } : { categoryName: undefined }
    );


    useEffect(() => {
        setSize("")
    }, [selectedValues.categories.length])


    useEffect(() => {
        if (openModal) {
            setSelectedValues({
                diamondQuality: "",
                goldQuality: "",
                goldColor: "",
                rhodium: "",
                categories: [],
            });
        }
    }, [openModal]);

    const [text, setText] = useState(remark);

    const [open, setOpen] = useState(false);

    const handleChange = (event) => {
        setSelectedValues((prev) => ({
            ...prev,
            [event.target.name]: event.target.value,
        }));
    };

    const handleCategoryChange = (event) => {
        setSelectedValues((prev) => ({ ...prev, categories: event.target.value }));
    };

    const MenuProps = {
        PaperProps: {
            sx: {
                maxHeight: "10vw",
                width: "12.5vw",
                marginTop: ".15vw",
                backgroundColor: "#FFFFFF",
                color: "#000000",
                borderRadius: ".25vw",
                padding: ".25vw !important",
                // ...menuStyles,
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                    display: "none",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "transparent",
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent",
                },
                "& .MuiList-root": {
                    "& .MuiMenuItem-root": {
                        fontFamily: "Karla",
                        padding: ".5vw .25vw !important",
                        margin: "0px 0px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignContent: "center",
                        "&:hover": {
                            backgroundColor: "#444444",
                            color: "#FFFFFF",
                            borderRadius: ".25vw",
                            margin: "0px 0px",
                        },
                    },
                },
            },
        },
    };

    // const getGoldValue = (goldQuality, goldColor) => {
    //     const colorMap = {
    //         Yellow: "Y",
    //         White: "W",
    //         Pink: "P",
    //     };

    //     const colorCode = colorMap[goldColor];
    //     return colorCode ? `${goldQuality.replace("K", "")}-${colorCode}` : "";
    // };

    const handleSubmit = () => {
        const { diamondQuality, goldQuality, goldColor, rhodium, categories } =
            selectedValues;

        setFilterValues({
            "Diamond Quality": diamondQuality ? [diamondQuality] : (filterValues["Diamond Quality"] || []),
            "Gold Purity": goldQuality ? [goldQuality] : (filterValues["Gold Purity"] || []),
            "Gold Color": goldColor ? [goldColorMap[goldColor]] : (filterValues["Gold Color"] || []),
            Rhodium: rhodium ? [rhodium] : (filterValues.Rhodium || []),
            categoriesName: categories.length > 0 ? categories : filterValues.categoriesName || [],
            size: size || filterValues.size || "",
        });
        setSize("");
        handleClose();
    };

    const handlePress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
        }
    };

    let content;
    switch (headLabel) {
        case "Search":
            content = ""
            break;
        case "Bulk Customization":
            content = (
                <>
                    <Box
                        sx={{
                            height: "100%",
                            padding: ".1vw",
                        }}
                    >
                        <Box marginBottom="1.25vw" onKeyDown={handlePress}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography className="filter-label">Categories</Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: ".5vw",
                                    }}
                                >
                                    <label
                                        style={{
                                            fontFamily: "Karla",
                                            fontSize: ".7vw",
                                            fontWeight: "700",
                                            color: "#595959",
                                        }}
                                    >
                                        All Categories
                                    </label>
                                    <CircularCheckbox
                                        color="success"
                                        checked={
                                            selectedValues?.categories?.length > 0 &&
                                            categoriesList.length ===
                                            selectedValues?.categories?.length
                                        }
                                        disableRipple
                                        onChange={(event) => {
                                            setSelectedValues({
                                                ...selectedValues,
                                                categories: event?.target?.checked
                                                    ? categoriesList
                                                    : [],
                                            });
                                        }}
                                    />
                                </Box>
                            </Box>
                            <Select
                                fullWidth
                                multiple
                                value={selectedValues.categories}
                                onChange={handleCategoryChange}
                                displayEmpty
                                open={open}
                                onOpen={() => setOpen(true)}
                                onClose={() => setOpen(false)}
                                input={
                                    <OutlinedInput
                                        fullWidth
                                        onKeyDown={handlePress}
                                        endAdornment={
                                            <InputAdornment position="start">
                                                <Box
                                                    sx={{
                                                        transition: "transform 0.3s ease",
                                                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        cursor: "pointer",
                                                        position: "absolute",
                                                        right: ".6vw",
                                                        top: "25%",
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setOpen(true);
                                                    }}
                                                >
                                                    <ArrowDown />
                                                </Box>
                                            </InputAdornment>
                                        }
                                    />
                                }
                                renderValue={(selected) =>
                                    selected.length === 0 ? (
                                        <Typography className="placeholder-label">
                                            Choose Categories
                                        </Typography>
                                    ) : (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: ".25vw",
                                                maxHeight: "4vw",
                                                width: "90%",
                                                overflowY: "auto",
                                                // border: "1px solid red !important",
                                                background: "#fff"
                                            }}
                                        >
                                            {selected.map((value) => (
                                                <Chip
                                                    key={value}
                                                    label={value}
                                                    deleteIcon={<Vector />}
                                                    onDelete={() => {
                                                        setSelectedValues((prev) => ({
                                                            ...prev,
                                                            categories: prev.categories.filter(
                                                                (cat) => cat !== value
                                                            ),
                                                        }));
                                                    }}
                                                    onMouseDown={(e) => e.stopPropagation()}
                                                    // className="modal-chip"
                                                    sx={{
                                                        fontFamily: "Karla",
                                                        fontWeight: "500",
                                                        fontSize: "18px",
                                                        lineHeight: "21.04px",
                                                        color: "#191818",
                                                        backgroundColor: "#D9D9D9",
                                                        width: "auto",
                                                        height: "32px",
                                                        borderRadius: "5px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    )
                                }
                                MenuProps={MenuProps}
                                sx={{
                                    marginTop: ".6vw",
                                    fontFamily: "Karla",
                                    fontSize: ".9vw",
                                    lineHeight: "1.1vw",
                                    fontWeight: 500,
                                    maxheight: "4vw",
                                    borderRadius: ".25vw",
                                    textTransform: "none",
                                    backgroundColor: "#FFFFFF",
                                    border: ".05vw solid #000000",
                                    padding: "0 .25vw !important",
                                    "& .MuiSelect-select": {
                                        padding: ".5vw .25vw !important",
                                    },
                                    "& .MuiSelect-icon": {
                                        display: "none",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&:focus": {
                                        backgroundColor: "transparent",
                                    },
                                }}
                            >
                                {categoriesList.map((name) => (
                                    <MenuItem
                                        key={name}
                                        value={name}
                                        sx={{
                                            fontSize: ".75vw",
                                            "&.Mui-selected": {
                                                backgroundColor: "#D9D9D9",
                                                borderRadius: ".25vw",
                                            },
                                        }}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>

                        {sizeData?.length > 0 && (<Box sx={{display: "flex", alignItems: "center", gap: 2, mb: 3}}>
                            <span style={{fontFamily: "Poppins", fontSize: "16px", fontWeight: 500}}>Size</span>
                            <Selectinput
                                options={sizeData}
                                value={size}
                                onchange={(e) => setSize(e.target.value)}
                                placeHolder={"None"}
                            >
                            </Selectinput>
                        </Box>)}

                        <CustomRadioGroup
                            label="Diamond Quality"
                            name="diamondQuality" // Add this
                            options={[
                                { label: "VVS-EF", value: "VVS-EF" },
                                { label: "VVS-FG", value: "VVS-FG" },
                                { label: "VVS-GH", value: "VVS-GH" },
                                { label: "VS-GH", value: "VS-GH" },
                                { label: "VSSI-GH", value: "VSSI-GH" },
                                { label: "SI-HI", value: "SI-HI" },
                                { label: "SI-IJ", value: "SI-IJ" },
                            ]}
                            value={selectedValues.diamondQuality}
                            onChange={handleChange}
                        />

                        {!(selectedValues?.categories?.some(cat => cat?.toLowerCase()?.includes("steel")) || (categoriesList.length > 0 && categoriesList.every(cat => cat?.toLowerCase()?.includes("steel")))) && (
                            <>
                                <CustomRadioGroup
                                    label="Gold Quality"
                                    name="goldQuality" // Add this
                                    options={[
                                        { label: "18K", value: "18K" },
                                        { label: "14K", value: "14K" },
                                    ]}
                                    value={selectedValues.goldQuality}
                                    onChange={handleChange}
                                />

                                <CustomRadioGroup
                                    label="Gold Color"
                                    name="goldColor" // Add this
                                    options={[
                                        { label: "Pink", value: "Pink", icon: <PinkGold /> },
                                        { label: "White", value: "White", icon: <WhiteGold /> },
                                        { label: "Yellow", value: "Yellow", icon: <YellowGold /> },
                                    ]}
                                    value={selectedValues.goldColor}
                                    onChange={handleChange}
                                />
                            </>
                        )}

                        <CustomRadioGroup
                            label="Rhodium"
                            name="rhodium"
                            options={[
                                { label: "White", value: "White",icon: <WhiteGold /> },
                                { label: "Pink", value: "Pink",icon: <PinkGold /> },
                                { label: "Yellow", value: "Yellow",icon: <YellowGold /> },
                            ]}
                            value={selectedValues.rhodium}
                            onChange={handleChange}
                        />
                    </Box>

                    <StyledButton
                        disabled={selectedValues.categories.length === 0}
                        onClick={handleSubmit}
                    >
                        Apply
                    </StyledButton>
                </>
            );
            break;
        default:
            content = (
                <>
                    <TextField
                        variant="standard"
                        placeholder="Enter your message"
                        multiline
                        rows={5}
                        onChange={(e) => setText(e.target.value)}
                        value={text}
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        sx={{
                            backgroundColor: "#F3F4F6",
                            borderRadius: ".4vw",
                            "& .MuiInputBase-root": {
                                fontFamily: "Karla",
                                fontWeight: 500,
                                color: "#101010",
                                fontSize: ".9vw",
                                lineHeight: "1.1vw",
                                letterSpacing: "-0.41px",
                                padding: ".6vw",
                            },
                        }}
                    />
                    <Box display="flex" justifyContent="flex-end" mt=".8vw">
                        <Button
                            sx={{
                                backgroundColor: "#50C878",
                                color: "#000000",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: ".7vw",
                                cursor: "pointer",
                                width: "5.25vw",
                                height: "1.75vw",
                                borderRadius: ".3vw",
                            }}
                            onClick={() => {
                                handleClose();
                                setRemark(text);
                            }}
                        >
                            Save
                        </Button>
                    </Box>
                </>
            );
    }

    return (
        <Modal
            open={openModal}
            onClose={() => {
                handleClose();
            }}
            sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
            <Grow in={openModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top:
                            headLabel === "Message"
                                ? "30%"
                                : headLabel === "Bulk Customization"
                                    ? "13%"
                                    : "15%",
                        width:
                            headLabel === "Search"
                                ? "auto"
                                : headLabel === "Bulk Customization"
                                    ? "28.65vw"
                                    : "23vw",
                        background: "white",
                        borderRadius: ".6vw",
                        padding: ".8vw",
                        outline: "none",
                        border: "none",
                        minWidth: "14vw",
                    }}
                    marginX="auto"
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb="1.2vw"
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: ".25vw", justifyContent: "space-between", width: "100%" }}>
                            {/* {headLabel === "Bulk Customization" && <Filter />} */}
                            <Typography
                                className="search-modal-title"
                                marginTop={headLabel === "Bulk Customization" ? ".1vw" : ".5vw"}
                            >
                                {headLabel}
                            </Typography>
                            <IconButton onClick={() => handleClose()} sx={{p:0}} >
                                <Close />
                            </IconButton>

                        </Box>
                        {/* <Box
                            className="modal-close"
                            onClick={() => {
                                handleClose();
                            }}
                            sx={{ cursor: "pointer" }}
                        >
                            {getIcon("Cross")}
                        </Box> */}
                    </Box>
                    {content}
                </Box>
            </Grow>
        </Modal>
    );
};

export default CartPageModal;